import TextFields, { TextFieldsProps } from './TextFields';

export type { TextFieldsProps };
export default TextFields;
